var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":"","color":_vm.isGeolocated ? 'green' : 'red'}},on),[_vm._v(" "+_vm._s(_vm.isGeolocated ? "location_on" : "location_off")+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.isGeolocated ? "Geolocalizado" : "Sin geolocalizar"))])])}
var staticRenderFns = []

export { render, staticRenderFns }